import vatFiles from '@config/vatFiles';
import { RULE_SECTIONS } from '@constants/config';
import { COUNTRIES } from '@constants/countries';
import { FILING_TYPES } from '@constants/filing';

/** A default config for all countries with country-specific overrides */
const countrySpecificRules = {
  [RULE_SECTIONS.DEFAULT]: {
    return: {
      downloadVATFiles: [vatFiles.DRAFT_RETURN, vatFiles.FILED_RETURN],
    },
    ecsl: {
      enableEcpl: false,
    },
    filing: {
      [FILING_TYPES.VAT]: {
        summary: {
          allowDataDownload: true,
        },
      },
      [FILING_TYPES.VPMT]: {
        summary: {
          allowDataDownload: true,
        },
      },
      [FILING_TYPES.AR]: {
        summary: {
          allowDataDownload: true,
        },
      },
      [FILING_TYPES.IOSS]: {
        summary: {
          allowDataDownload: true,
          disableViewEdit: true,
        },
        upload: {
          disableOnlineSpreadsheet: true,
          disableConversionTool: true,
        },
        troubleshoot: {
          disableOnlineTroubleshoot: true,
        },
      },
      [FILING_TYPES.OSS]: {
        summary: {
          allowDataDownload: true,
          disableViewEdit: true,
        },
        upload: {
          disableOnlineSpreadsheet: true,
          disableConversionTool: true,
        },
        troubleshoot: {
          disableOnlineTroubleshoot: true,
        },
      },
      [FILING_TYPES.ECSL]: {
        upload: {
          disableGameChanger: true,
        },
      },
    },
    noPaymentDetailsCheck: false,
    registrations: {
      hasLocalVatNumber: false,
      hasFiscaleCode: false,
    },
    showElsterSubmission: false,
    showHMRCSubmission: false,
  },
  [COUNTRIES.AT]: {
    registrations: {
      hasLocalVatNumber: true,
    },
  },
  [COUNTRIES.CZ]: {
    return: {
      downloadVATFiles: [vatFiles.XML, vatFiles.DRAFT_RETURN],
    },
  },
  [COUNTRIES.DE]: {
    registrations: {
      hasLocalVatNumber: true,
    },
    showElsterSubmission: true,
  },
  [COUNTRIES.ES]: {
    ecsl: {
      enableEcpl: true,
    },
    registrations: {
      hasLocalVatNumber: true,
    },
  },
  [COUNTRIES.GB]: {
    showHMRCSubmission: true,
  },
  [COUNTRIES.IT]: {
    return: {
      downloadVATFiles: [vatFiles.XML, vatFiles.DRAFT_RETURN],
    },
    filing: {
      [FILING_TYPES.VAT]: {
        summary: {
          allowDataDownload: false,
        },
      },
    },
    registrations: {
      hasFiscaleCode: true,
    },
  },
  [COUNTRIES.PL]: {
    return: {
      downloadVATFiles: [vatFiles.SAFT, vatFiles.XML, vatFiles.DRAFT_RETURN],
    },
    noPaymentDetailsCheck: true,
  },
};

export { countrySpecificRules as default };
